// extracted by mini-css-extract-plugin
export default {"root":"LoadingPlaceholder_root__7XxVX","content":"LoadingPlaceholder_content__-Tbyd","title":"LoadingPlaceholder_title__TSqev","reveal":"LoadingPlaceholder_reveal__MqX5g"};